/*global FormController, WebView, moment*/
var docMergePdfPopupController = new FormController("ir_attachment",
    {
        directory: "views/attach",
        name: "docMergePdf",
        route: "doc-merge-pdf-popup",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        popup: {
            title: "",
            //size can by small, medium, large and wide
            size: "medium"
        }
    }
);

docMergePdfPopupController.prepareDataOnEnter = function(data, callback){
    if(!data || typeof(data) === "object"){
        //received a full object or nothing, go ahead with it
        return callback(null, data) ;
    }
} ;

//the popup will never be in read mode, switch to create or modify
docMergePdfPopupController.onChangeMode = function(ev){
    if(ev.data === "read"){
        if(!this.data.id){
            this.setMode("create") ;
        }else{
            this.setMode("modify") ;
        }
    }
} ;

docMergePdfPopupController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};

//close when user click on cancel button
docMergePdfPopupController.onCancel = function(){
    this.view.close() ;
};

docMergePdfPopupController.onValidate = function(){
    this.view.updateData() ;
    this.view.longTask(function(done){
        this.api.readManyPdf.download(this.data.docs.map(function(p){ return p.attach_id; }), (this.data.filename||"file")+".pdf", function(err){
            if(err){ return done(err) ; }
            done() ;
            this.mode = 'read' ; //avoid abort input warning
            this.view.close() ;
        }.bind(this)) ;
    }.bind(this)) ;
};



module.exports = docMergePdfPopupController ;